/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirmupgradeproration2Inputs */

const en_confirmupgradeproration2 = /** @type {(inputs: Confirmupgradeproration2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unused time on your current plan is credited pro rata. Confirming charges the remaining amount to your saved payment method straight away. You will not be taken to the payment page for this.`)
};

const de_confirmupgradeproration2 = /** @type {(inputs: Confirmupgradeproration2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verbrauchte Zeit deines aktuellen Plans wird anteilig gutgeschrieben. Der Restbetrag wird mit der Bestätigung sofort über deine hinterlegte Zahlungsmethode abgebucht. Du wirst dafür nicht mehr zur Bezahlseite weitergeleitet.`)
};

/**
* | output |
* | --- |
* | "Unused time on your current plan is credited pro rata. Confirming charges the remaining amount to your saved payment method straight away. You will not be ta..." |
*
* @param {Confirmupgradeproration2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmupgradeproration2 = /** @type {((inputs?: Confirmupgradeproration2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmupgradeproration2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmupgradeproration2(inputs)
	return de_confirmupgradeproration2(inputs)
});
export { confirmupgradeproration2 as "confirmUpgradeProration" }